/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversions use standard international factors and are computed at full floating-point precision, then rounded for display. Results are accurate for everyday and most technical use.`)
};

const es_uc_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las conversiones utilizan factores estándar internacionales y se calculan con precisión completa de punto flotante, luego se redondean para su visualización. Los resultados son precisos para uso cotidiano y técnico.`)
};

const de_uc_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Umrechnungen verwenden internationale Standardfaktoren und werden mit voller Gleitkomma-Genauigkeit berechnet und für die Anzeige gerundet. Die Ergebnisse sind für den Alltag und die meisten technischen Anwendungen genau genug.`)
};

const nl_uc_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversies gebruiken standaard internationale factoren en worden berekend met volledige drijvende-kommaprecisie, vervolgens afgerond voor weergave. Resultaten zijn nauwkeurig voor alledaags en het meeste technisch gebruik.`)
};

const fr_uc_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les conversions utilisent des facteurs internationaux standards et sont calculées à la précision complète en virgule flottante, puis arrondies pour l'affichage. Les résultats sont précis pour un usage quotidien et la plupart des usages techniques.`)
};

const it_uc_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le conversioni utilizzano fattori internazionali standard e vengono calcolate con precisione in virgola mobile completa, quindi arrotondate per la visualizzazione. I risultati sono accurati per l'uso quotidiano e nella maggior parte dei casi tecnici.`)
};

const pt_br2_uc_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As conversões usam fatores internacionais padrão e são computadas com precisão completa de ponto flutuante, depois arredondadas para exibição. Os resultados são precisos para uso cotidiano e a maioria dos usos técnicos.`)
};

const pt_uc_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As conversões utilizam factores internacionais padronizados e são calculadas com precisão total de ponto flutuante, depois arredondadas para apresentação. Os resultados são precisos para utilização diária e para a maioria das aplicações técnicas.`)
};

const ja_uc_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変換は標準的な国際係数を使用し、完全な浮動小数点精度で計算され、表示のために丸められます。結果は日常と大部分の技術用途に対して正確です。`)
};

const zh_uc_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_hub_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_hub_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_hub_faq1_a", locale)
	if (locale === "en") return en_uc_hub_faq1_a(inputs)
	if (locale === "es") return es_uc_hub_faq1_a(inputs)
	if (locale === "de") return de_uc_hub_faq1_a(inputs)
	if (locale === "nl") return nl_uc_hub_faq1_a(inputs)
	if (locale === "fr") return fr_uc_hub_faq1_a(inputs)
	if (locale === "it") return it_uc_hub_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_hub_faq1_a(inputs)
	if (locale === "pt") return pt_uc_hub_faq1_a(inputs)
	if (locale === "ja") return ja_uc_hub_faq1_a(inputs)
	return zh_uc_hub_faq1_a(inputs)
};